import { Outlet } from "react-router-dom";

import { NoFarmsPage } from "../../../../pages/auth-info/containers/no-farms-page";
import { SpinnerCenter } from "../../../../shared/components/spinner-center/spinner-center";
import { useDictionaryLoader } from "../../../../shared/hooks/use-dictionary-loader";
import { useFarmFeatureToggles } from "../../../../shared/hooks/use-farm-feature-toggles";

import { useAvailableFarmsGate } from "./use-available-farms-gate";

export const InitialDataGate = () => {
  const farms = useAvailableFarmsGate();
  const initialDictionariesLoaded = useDictionaryLoader();
  useFarmFeatureToggles();

  if (farms.status === "empty") {
    return <NoFarmsPage onRetry={farms.retry} />;
  }
  if (farms.status !== "ready") {
    return <SpinnerCenter msg="Загружаются хозяйства..." />;
  }
  if (!initialDictionariesLoaded) {
    return <SpinnerCenter msg="Загружаются справочники..." />;
  }

  return <Outlet />;
};
